jQuery(document).ready(function($){

    $('.team-fancybox__team_carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
    });

    $('.team-fancybox__workplace_carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
    });

    $('.team-fancybox__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: false,
        autoplay: false
    });

    $('.team-fancybox__team_carousel').each(function () {
        const $carousel = $(this);

        if ($carousel.find('.slick-slide').not('.slick-cloned').length <= 1) {
            $carousel.addClass('hide-dots');
        }
    });

    $('.team-fancybox__workplace_carousel').each(function () {
        const $carousel = $(this);

        if ($carousel.find('.slick-slide').not('.slick-cloned').length <= 1) {
            $carousel.addClass('hide-dots');
        }
    });

    $('.team-fancybox__carousel').each(function () {
        const $carousel = $(this);

        if ($carousel.find('.slick-slide').not('.slick-cloned').length <= 1) {
            $carousel.addClass('hide-dots');
        }
    });

    $('.customer-stories-carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: true,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
            { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    });



    $('.latest_projects_news_carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: true,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    });

    $('.awards-logos__carousel').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 5 } },
            { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } }
        ]
    });

     $('.testimonals_carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: true,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    });
});